const icon = require('vue-svgicon');
icon.register({
    'triangle': {
        width: 18,
        height: 18,
        viewBox: '0 0 18 18',
        data: `<path pid="0" d="M13 11L9 7l-4 4h8z"/>`,
    },
});
